import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, first } from 'rxjs';
import { environment } from 'public/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MyprofileService {
  refreshDetails = new BehaviorSubject<boolean>(false);
  constructor(private http: HttpClient) { }
  GetUser(id: any): any {
    return this.http.get(`${environment.apiUrl}/accounts/GetUser/` + id);
  }

  AssignMembershipNumberToUser(model:any): any {
    return this.http.put(`${environment.apiUrl}/accounts/AssignMembershipNumberToUser`, model);
  }
  getMembershipInfo(params:any): any {
    return this.http.get(`${environment.apiUrl}/accounts/GetMembershipInfo`, { params });
  }
  GoOffline(status: any): any {
    return this.http.get(`${environment.apiUrl}/accounts/GoOffline?status=` + status);
  }
  getEntities(entitiesObj: any): any {
    return this.http.post(`${environment.apiUrl}/CollectionEntity/GetCollectionsForUserProfile`, entitiesObj);
  }
  GetUserGroups(UserGroupsObj: any): any {
    return this.http.post(`${environment.apiUrl}/groups/GetGroupsForUserProfile`, UserGroupsObj);
  }
  AddUserSigneture(formData: any): any {
    return this.http.post(`${environment.apiUrl}/accounts/AddUserSigneture`, formData);
  }
  getUserProfile() {
    return this.http.get(`${environment.apiUrl}/accounts/UserProfile`)
  }
}
